import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { Stack } from "@mui/material";
import { OpacityDisplay } from "components/dataDisplay/OpacityDisplay";
import { ColorSearchMultiSelect } from "components/input/colorSearchMultiSelect/ColorSearchMultiSelect";
import type { Dispatch } from "react";
import { useTranslation } from "react-i18next";
import { getOpacityValues } from "service/autocomplete-lookup";

export interface OpacityFilterProps {
  value: Array<AutocompleteData> | undefined;
  onChange: Dispatch<Array<AutocompleteData>>;
}

export const OpacityFilter = ({ value = [], onChange }: OpacityFilterProps) => {
  const options = getOpacityValues();
  const { t } = useTranslation();
  return (
    <ColorSearchMultiSelect
      options={options}
      onChange={onChange}
      formatOptionText={(option) => (
        <Stack width="100%" direction="row" justifyContent="space-between">
          {option.name}
          <OpacityDisplay fontSize={"small"} value={option.value} />
        </Stack>
      )}
      value={value}
      label={t("filter_color_opacity")}
    />
  );
};
